module.exports = __webpack_public_path__ + "tables/media/Charts_outlined.883aa3ec.svg";